export default __webpack_public_path__ + "assets/images/55ca4212b382ac65b8788711c86983d4.svg";